import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import { Badge } from 'ziphy-web-shared/basic/lib/simple';
import styles from './Breadcrumbs.module.scss';
const Breadcrumbs = ({ values, className }) => {
    return (_jsx("div", Object.assign({ className: classNames(styles.wrapper, className) }, { children: !_.isEmpty(values) &&
            values.map((x, i) => !_.isEmpty(x) && (_jsx(Badge, Object.assign({ mode: ['gray', 'sm', 'outline', 'minHeight32'], className: styles.item }, { children: x }), `breadcrumb-badge-${i}`))) })));
};
export default Breadcrumbs;
